import { ChangeDetectionStrategy, Component, CreateEffectOptions, effect, EventEmitter, inject, Input, Output, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MiniOperationsStore } from 'src/app/store/mini-operations-store';
import { QuestionType } from 'src/app/models/questionType.model';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { SignatureDisplayComponent } from '../../../question-form-display/components/signature-display/signature-display.component';
import { ToggleComponent } from 'src/app/shared/components/toggle/toggle.component';
import { AbstractControl, ControlValueAccessor, FormBuilder, FormControl, FormsModule, NG_VALIDATORS, NG_VALUE_ACCESSOR, ReactiveFormsModule, ValidationErrors, Validator } from '@angular/forms';
import { OptionsList } from 'src/app/models/optionsList.model';
import { Validators } from 'ngx-editor';
import { Question } from 'src/app/models/question.model';

@Component({
    selector: 'que-signature',
    imports: [CommonModule, TranslateDirective, TranslatePipe, SignatureDisplayComponent, ToggleComponent, ReactiveFormsModule, FormsModule],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: SignatureComponent,
            multi: true
        }
    ],
    templateUrl: './signature.component.html',
    styleUrls: ['./signature.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SignatureComponent implements ControlValueAccessor {

  @Output() focusEvent = new EventEmitter<boolean>();
  @Input()
  index?: number
  @Input()
  type?: QuestionType

  includeDate$ = signal(false);
  SetIncludeDate(state: boolean) {
    this.includeDate$.set(state);
  }
  orginalQuestion?: Question;
  registerOnChangeCallback: any = () => { };

  constructor() {
    const options: CreateEffectOptions = { allowSignalWrites: true };
    effect(() => this.registerOnChangeCallback({ ...this.orginalQuestion, isIncludeDate: this.includeDate$() }), options);
  }
  writeValue(obj: Question): void {
    this.orginalQuestion = obj;
    if (this.includeDate$() != obj.isIncludeDate) {
      this.includeDate$.set(obj.isIncludeDate ?? false);
    }
  }
  registerOnValidatorChange?(fn: () => void): void {
  }

  registerOnChange(fn: any): void {
    this.registerOnChangeCallback = fn;
  }
  registerOnTouched(fn: any): void {
  }
}
